<template>
<div>
  
  <section class="timeline" v-bind:class="{ 'timeline__invert': isInvert}">
    <div class="row timeline__container">
      <div class="col-sm-6 timeline__imgcontainer" v-bind:class="{ 'order-sm-2': isInvert }">
        <div class="year__img">
          <div class="year_img__title" v-html="year_before + ' ' + year"/>
        </div>
        <div class="timeline__img">
          <div  v-if="images" ref="gallery">
            <img v-for="img in images" v-bind:key="img" v-bind:src="img"  />
          </div>
        </div>
      </div>
      <div class="col-sm-6 timeline_text__container" v-bind:class="{ 'order-sm-1': isInvert }">
        <div class="year_box">
          <div class="year_box__title" v-html="year_before"/>
          <div class="year_box__year" v-html="year"/>
        </div>
        <div class="timeline_text__text">
          <p v-if="text" v-html="text"></p>
        </div>
      </div>
    </div>
  </section>
  </div>
</template>

<script>
import { TweenMax, Power0, Power1, Power2, CSSPlugin } from "gsap";
import TimelineMax from "gsap/TimelineMax";

import { tns } from "tiny-slider/src/tiny-slider"
require("tiny-slider/src/tiny-slider.scss")
import 'intersection-observer'


export default {
  name: 'Banner',
  props: {
    year: String,
    year_before: String,
    text: String,
    images: Array,
    isInvert: Boolean,
    bus: {}
  },
  data() {
    return {
      timelines: []
    }
  },
  methods: {
    TimeLineFactory(conf) {
      conf = conf || {}
      let t = new TimelineMax(conf)
      this.timelines.push(t)
      return t
    }
  },
  beforeDestroy() {
    for(let t of this.timelines) {
      t.kill()
    }
    TweenMax.killChildTweensOf(this.$el)
  },
  components: {
    
  },
  mounted() {
    this.id = this._uid
    require("@/js/vendor/SplitText.js")

    if (this.$refs.gallery && this.$refs.gallery.querySelectorAll('img').length > 1) {
      let slider = tns({
        container: this.$refs.gallery,
        items: 1,
        autoplay: true,
        mode: 'gallery',
        controls: true,
        nav: false,
        autoplayButton: false
      });
    }
    
    this.$nextTick(() => {
      let ytitle = new SplitText(this.$el.querySelector('.year_img__title'), {type: 'chars'})
      let options = {
        rootMargin: '0px',
        threshold: 0.2
      };
      const tl = this.TimeLineFactory({
        paused: true
      })
      tl.addLabel('start')

      tl.set(this.$el.querySelector('.timeline_text__container'), {className: '+=animate', immediateRender: false}, 'start')
      tl.set(this.$el.querySelector('.year_box'), {className: '+=animate', immediateRender: false}, 'start+=0.2')
      tl.staggerFrom(ytitle.chars, 0.8, {yPercent: 100, ease: Power2.easeOut}, 0.1, '+=1')
      let obs = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio > 0) {
            tl.play();
            obs.unobserve(entry.target);
          }
        });
      }, options);
      obs.observe(this.$el)
      
    })
  }
}
</script>

<style scoped lang="scss">


</style>

<style lang="scss">
.tns-outer {
  .tns-liveregion,
  [data-action="stop"] {
    display: none;
  }
}

.tns-controls {
  position: absolute;
  bottom: -50px;
  [data-controls="prev"],
  [data-controls="next"] {
    border: none;
    color: transparent;
    background: none;
  }
  [data-controls="next"],
  [data-controls="prev"] {
    background: transparent url('~@/assets/img/arrow_left.svg') no-repeat center center;
  }
  [data-controls="next"] {
    transform: scale(-1);
  }
}
[data-action="start"] {
  display: none;
}
.year_box {
  color: black;
  font-size: 80px;
  font-weight: 200;
  font-family: $headings-font-family;
  width: 100px;
  height: 100px;
  overflow: hidden;
  padding-left: 5px;
  position: relative;
  &:before {
    content: '';
    position: absolute;
    z-index: 0;
    width: 100%;
    height: 100%;
    background: $red;
    transform: translateY(100%);
    transition: transform 1s cubic-bezier(.17,.84,.44,1);
  }
  &.animate:before {
    transform: translateY(0);
  }
  > div {
    position: relative;
    z-index: 1;
  }
}
.year_box__title {
  color: white;
  font-size: 12px;
  letter-spacing: 3.8px;
  font-weight: 600;
  text-transform: uppercase;
  padding-left: 10px;
  position: relative;
  top: 18px;
}
@at-root html[lang="en"] .year_box__year {
  font-size: 65px;
  margin-top: 12px;
  sup {
    font-size: 40%;
    font-weight: 300;
    top: -1em;
  }
}

.timeline__img {
  position: relative;
  &:after {
    content: '';
    position: absolute;
    z-index: 1;
    width: 134px;
    height: 134px;
    display: block;
    background: $gray;
    bottom: -15px;
    left: -15px;
  }
  > div {
    position: relative;
    z-index: 2;
  }
}

.timeline__invert {
  .timeline__img {
    &:after {
      left: auto;
      right: -15px;
    }
  }
}

.timeline_text__container {
  color: white;
  position: relative;
  padding-top: 40px;
  padding-bottom: 40px;
  &:before {
    content: '';
    position: absolute;
    display: block;
    z-index: 0;
    top: 0;
    background: black;
    transition: transform 1.2s cubic-bezier(.17,.84,.44,1);
    transform: translateX(100%);
    
    height: 100%;
    width: 110vw;
  
    left: -15px;
  
    @include media-breakpoint-up(sm) {
      left: -130px;
      width: 65vw;
      min-width: 700px;
      max-width: 1600px;
    }
  }
  &.animate:before {
    transform: translateX(0) !important;
  }
  > div {
    position: relative;
    z-index: 2;
  }
}

.timeline_text__container {
  @include media-breakpoint-down(sm) {
    margin-top: 50px;
  }
  @include media-breakpoint-up(lg) {
    padding-left: 80px;
  }
}

.timeline_text__text {
  margin-top: 50px;
  margin-bottom: 20px;
}

.timeline__invert {
  .timeline_text__container {
    @include media-breakpoint-up(lg) {
      padding-left: 0;
    }
  }
  .timeline_text__container:before {
    left: auto;
    right: 0;
    @include media-breakpoint-up(sm) {
      right: -130px
    }
    
    transform: translateX(-100%);
  }

  .timeline_text__text {
    @include media-breakpoint-up(md) {
      padding-right: 20px;
    }
    @include media-breakpoint-up(lg) {
      padding-right: 80px;
      padding-left: 0px;
    }
  }
}

.timeline__imgcontainer {
  position: relative;
  display: flex;
  flex-direction: column;
  margin-top: 50px;
  @include media-breakpoint-only(md) {
    margin-top: 10%;
    margin-bottom: auto;
  }
}
.year__img {
  transform: rotate(90deg);
  top: 140px;
  font-size: 86px;
  line-height: 1em;
  overflow: hidden;
  font-weight: 200;
  font-style: normal;
  font-stretch: normal;
  line-height: 0.88;
  letter-spacing: 7.8px;
  color: #242424;
  position: absolute;
  z-index: 1;
  right: -200px;
  > div {
    display: inline-block;
  }
}

.timeline__invert {
  .year__img {
    right: auto;
    left: -200px;
    transform: rotate(-90deg);
  }
}

</style>

